import { render, staticRenderFns } from "./provid.vue?vue&type=template&id=9429d046&scoped=true&"
import script from "./provid.vue?vue&type=script&lang=js&"
export * from "./provid.vue?vue&type=script&lang=js&"
import style0 from "./provid.vue?vue&type=style&index=0&id=9429d046&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9429d046",
  null
  
)

export default component.exports